import { DesignRole, ROLE_DEFINITIONS } from "@multiconsult-group/multiplacer-core";
import { ROLE_ICON_BY_KEY } from "../DesignTab/designModuleIcons";

export const RoleChip: React.FC<{ role: DesignRole }> = ({ role }) => {
  const def = ROLE_DEFINITIONS[role];
  const Icon = ROLE_ICON_BY_KEY[role];

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <Icon size={16} />
      <span>{def.label}</span>
    </div>
  );
};
